
import { html, css } from 'lit';
import { property } from 'lit/decorators.js';
import { KryptonElement } from './krypton-element';
export class KryptonTabs extends KryptonElement {
    @property({ type: String }) accessor selected: String
    @property({ type: String }) accessor name: String

    static styles = css`
        .active-tabs {
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
            padding: 4px;
            background: #004693;
            color: #FFFFFF;
            border-color: #004693;
            border-top-left-radius: 5px;
            border-top-right-radius: 15px;
            line-height: 2;
            padding-right: 15px;
            padding-left: 15px;
            min-width: 120px;
            cursor: pointer;
            display: inline-block;
            margin-right: 1px;
        }
        .inactive-tabs {
            opacity: .35;
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
            padding: 4px;
            background: #004693;
            color: #FFFFFF;
            border-color: #004693;
            border-top-left-radius: 5px;
            border-top-right-radius: 15px;
            line-height: 2;
            padding-right: 15px;
            padding-left: 15px;
            min-width: 120px;
            cursor: pointer;
            display: inline-block;
            margin-right: 1px;
        }
    `;

    render() {
        return html`
            <div id="tabs-div" class="row"></div>
            <slot @slotchange="${this.onSlotChange}"></slot>
        `;
    }
    onSlotChange() {
        let tabsDiv = this.shadowRoot?.querySelector("#tabs-div");
        this.querySelectorAll("[krypton-route]").forEach(e => {
            const el: any = document.createElement("div");
            el.classList.add("inactive-tabs")
            el.textContent = e.getAttribute("krypton-route") || '';
            tabsDiv?.appendChild(el);
            el.addEventListener("click", (e: Event) => this.clickHandler(e));
            el.associatedDiv = e;
        });
        this.selectTabCss();
    }
    clickHandler(e: Event) {
        let sel: any = e?.target;
        this.selected = sel?.textContent || ''
        this.selectTabCss();
    }
    selectTabCss() {
        var tabsDivs = this.shadowRoot?.querySelector("#tabs-div")?.querySelectorAll('div');
        tabsDivs?.forEach(e => {
            if (this.selected === e.textContent) {
                e.classList.add("active-tabs");
                e.classList.remove("inactive-tabs");
                (e as any).associatedDiv.style.display = "block"
            } else {
                e.classList.add("inactive-tabs");
                e.classList.remove("active-tabs");
                (e as any).associatedDiv.style.display = "none"
            }
        });
    }
}
declare global {
    interface HTMLElementTagNameMap {
        'krypton-tabs': KryptonTabs;
    }
}
